import { View } from 'react-native'
import { Divider, Icon, Text, useTheme } from 'react-native-paper'
import { formatAddress, isNonBlankAddress } from '@/lib/address'

interface AddressPanelProps {
    address: unknown
    showDivider?: boolean
    title?: string
}

export function AddressPanel({
    address,
    showDivider = true,
    title = 'Address',
}: AddressPanelProps) {
    const theme = useTheme()

    if (!isNonBlankAddress(address)) {
        return null
    }

    return (
        <>
            <View style={{ gap: 8 }}>
                <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                    <Icon source="map-marker" size={16} color={theme.colors.onSurfaceVariant} />
                    <Text variant="bodyLarge" style={{ fontWeight: '600' }}>
                        {title}
                    </Text>
                </View>
                <View style={{ gap: 4, paddingLeft: 24 }}>
                    <Text variant="bodyLarge">{formatAddress(address)}</Text>
                </View>
            </View>
            {showDivider && <Divider />}
        </>
    )
}
